// Hyper-local Bath neighbourhood guides — SEO content + live market lookup postcodes.
export const AREA_GUIDES = [
  {
    slug: "widcombe",
    salesPostcode: "BA2 6AA",
    city: "Bath",
    name: "Widcombe",
    postcode: "BA2",
    tagline: "A village within the city — canal walks, indie cafés and Georgian charm",
    heroImage: "https://images.unsplash.com/photo-1782511860958-84d44a9dd033?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Tucked just south of Bath's centre, Widcombe feels like a village that happens to sit five minutes from the station. Its high street — Widcombe Parade — is lined with independent delis, wine bars and the beloved Widcombe Social Club, while the Kennet & Avon Canal and Alexandra Park deliver some of the finest views over the city.",
    intro2:
      "Property here is a mix of handsome Georgian terraces, canalside cottages and characterful conversions. It's a perennial favourite with professionals, downsizers and families who want walkability and community without sacrificing period character.",
    highlights: ["Widcombe Parade independents", "Kennet & Avon Canal towpath", "Alexandra Park skyline views", "5-min walk to Bath Spa station"],
    transport: "Bath Spa station (London Paddington ~90 mins) is a short stroll; the A36 gives quick access towards the M4 and Bristol.",
    schools: ["Widcombe Junior School (Ofsted Good)", "Widcombe Infant School", "Ralph Allen School (secondary)"],
    vibe: "Community-minded, creative and green — a foodie village mood minutes from the Abbey.",
    priceGuide: "Terraces from ~£550k; canalside cottages £400k–£700k; family homes £750k+.",
    whyInvest: "Consistent tenant demand from professionals and postgraduates, low void periods, and a scarcity of stock that supports strong capital growth.",
  },
  {
    slug: "lansdown",
    salesPostcode: "BA1 5EX",
    city: "Bath",
    name: "Lansdown",
    postcode: "BA1",
    tagline: "Elevated Georgian grandeur with the city at your feet",
    heroImage: "https://images.pexels.com/photos/37623657/pexels-photo-37623657.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
    intro:
      "Rising north of the centre, Lansdown is home to some of Bath's most iconic addresses — Lansdown Crescent, Somerset Place and Camden Crescent — where sweeping Georgian architecture meets panoramic city views. It's prestigious, leafy and wonderfully quiet.",
    intro2:
      "Expect grand crescent apartments, substantial townhouses and detached villas with gardens. Lansdown attracts families drawn to top schools and buyers seeking landmark period homes with genuine wow-factor.",
    highlights: ["Lansdown & Somerset Place crescents", "Bath Racecourse", "Prior Park & National Trust views", "Highgate & Approach golf clubs nearby"],
    transport: "A 15-minute walk (or quick bus) into the centre; the A46 links directly to the M4 (J18) for London and the Cotswolds.",
    schools: ["Kingswood School (independent)", "Royal High School Bath (GDST)", "St Stephen's C of E Primary (Good)"],
    vibe: "Refined, residential and green — landmark living with the best long views in Bath.",
    priceGuide: "Crescent apartments £450k–£900k; townhouses £1m+; detached villas £1.5m+.",
    whyInvest: "Trophy addresses with limited supply hold value exceptionally well; premium rentals let quickly to relocating executives and academic families.",
  },
  {
    slug: "bathwick",
    salesPostcode: "BA2 4DZ",
    city: "Bath",
    name: "Bathwick",
    postcode: "BA2",
    tagline: "Great Pulteney Street elegance beside the river and Sydney Gardens",
    heroImage: "https://images.unsplash.com/photo-1571990925697-39f8227cc2c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Bathwick is Georgian Bath at its most theatrical — Great Pulteney Street's broad boulevard, the Holburne Museum and the tranquil Sydney Gardens all sit within its bounds, moments across Pulteney Bridge from the city centre.",
    intro2:
      "The housing stock is dominated by elegant terraces, mansion-block apartments and smart mews conversions. It's a magnet for those who want to walk everywhere and live surrounded by heritage.",
    highlights: ["Great Pulteney Street", "Holburne Museum", "Sydney Gardens & the canal", "Steps from Pulteney Bridge"],
    transport: "Everything is walkable — the centre and Bath Spa station are 5–10 minutes on foot.",
    schools: ["Bathwick St Mary C of E Primary (Good)", "St Mark's C of E School", "Close to Kingswood & King Edward's"],
    vibe: "Central, cultured and unmistakably Georgian — the classic Bath postcard address.",
    priceGuide: "Apartments £350k–£800k; whole terraces £1m–£2m+.",
    whyInvest: "Prime central location commands premium short- and long-let rents; heritage appeal underpins durable demand from buyers worldwide.",
  },
  {
    slug: "larkhall",
    salesPostcode: "BA1 6RL",
    city: "Bath",
    name: "Larkhall",
    postcode: "BA1",
    tagline: "Bath's friendliest urban village — colourful, connected and coveted",
    heroImage: "https://images.pexels.com/photos/2049896/pexels-photo-2049896.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
    intro:
      "Larkhall wins hearts with its pastel-painted terraces, a proper village square and a genuinely independent high street — think a butcher, a theatre, a bakery and a clutch of cafés all within a few steps.",
    intro2:
      "Homes range from artisan cottages and Victorian terraces to family houses with gardens. It's especially popular with young families and creatives priced out of the very centre but unwilling to lose the community feel.",
    highlights: ["Larkhall Square independents", "The Rondo Theatre", "Alice Park", "Easy reach of the centre"],
    transport: "Regular buses reach the centre in ~10 minutes; the A4/A46 give onward links to the M4.",
    schools: ["St Saviour's C of E Junior & Infant (Good)", "St Mark's C of E School", "Larkhall pre-schools"],
    vibe: "Sociable, bohemian and great value — the neighbourhood everyone seems to love.",
    priceGuide: "Cottages from ~£375k; Victorian terraces £450k–£650k; family homes £700k+.",
    whyInvest: "Strong, steady rental demand and a rising profile make Larkhall a reliable buy-to-let with room for growth.",
  },
  {
    slug: "combe-down",
    salesPostcode: "BA2 5DE",
    city: "Bath",
    name: "Combe Down",
    postcode: "BA2",
    tagline: "Leafy hilltop living with country air and city convenience",
    heroImage: "https://images.unsplash.com/photo-1759497582478-9b4716c562ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "High on the southern hills, Combe Down offers a greener, more spacious pace of life — with Bath stone cottages (the very stone that built the city was quarried here), open countryside and the National Trust's Bath Skyline walk on the doorstep.",
    intro2:
      "You'll find everything from characterful cottages to substantial detached family homes, many with generous gardens and parking that's hard to come by in the centre.",
    highlights: ["Bath Skyline & Prior Park", "Combe Down village shops", "Excellent local schooling", "Countryside on your doorstep"],
    transport: "A 10–15 minute drive or bus into the centre; the A36/A367 head south towards Wells and the A46 north to the M4.",
    schools: ["Combe Down C of E Primary (Good)", "Monkton Combe School (independent)", "Ralph Allen School (secondary)"],
    vibe: "Green, family-friendly and peaceful — space to breathe minutes from the city.",
    priceGuide: "Cottages £450k–£650k; detached family homes £750k–£1.2m+.",
    whyInvest: "Family-sized homes with gardens are in short supply and let to long-term, low-turnover tenants — ideal for stable yields.",
  },
  {
    slug: "weston",
    salesPostcode: "BA1 4AR",
    city: "Bath",
    name: "Weston",
    postcode: "BA1",
    tagline: "A historic village enclave with green space and gentle prices",
    heroImage: "https://images.unsplash.com/photo-1665313939235-bcad66c1e92a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Weston retains a distinct village identity around All Saints Church and Weston High Street, ringed by green space at Victoria Park's edge and the western hills, yet only a short hop from the centre.",
    intro2:
      "The mix of period cottages, 1930s semis and modern family homes makes Weston one of the more accessible ways into desirable BA1 living, popular with families and first-time buyers alike.",
    highlights: ["Weston High Street & village green", "Royal Victoria Park nearby", "Kelston Round Hill walks", "Good value for BA1"],
    transport: "Frequent buses into the centre in ~15 minutes; quick links to the RUH hospital and the A4 west to Bristol.",
    schools: ["Weston All Saints C of E Primary (WASPS, Good)", "St Andrew's C of E Primary", "Close to Oldfield & Royal High"],
    vibe: "Down-to-earth, green and welcoming — village life without the premium price tag.",
    priceGuide: "Semis & cottages £350k–£550k; larger family homes £600k+.",
    whyInvest: "Affordable entry prices plus proximity to the RUH hospital drive dependable rental demand from healthcare professionals.",
  },
  {
    slug: "clifton",
    salesPostcode: "BS8 4AB",
    city: "Bristol",
    name: "Clifton",
    postcode: "BS8",
    tagline: "Bristol's most elegant address — Georgian crescents, boutiques and the famous bridge",
    heroImage: "https://images.unsplash.com/photo-1784471397628-944644323565?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Clifton is Bristol at its most refined — sweeping Georgian and Regency crescents, the world-famous Clifton Suspension Bridge, independent boutiques along Clifton Village, and the green expanse of the Downs on its doorstep.",
    intro2:
      "Housing spans grand terraces and crescents, mansion-flat conversions and smart townhouses. It's a magnet for professionals, academics (the University is close) and families drawn to its village feel and superb schools.",
    highlights: ["Clifton Suspension Bridge & the Downs", "Clifton Village boutiques", "Bristol Zoo Gardens heritage", "Close to the University & city centre"],
    transport: "Walkable to the centre; Clifton Down station and the A4/M32 give quick links; Bristol Temple Meads (London ~90 mins) is a short ride.",
    schools: ["Clifton College (independent)", "Clifton High School", "The Downs School nearby"],
    vibe: "Elegant, leafy and cosmopolitan — Bristol's most prestigious village.",
    priceGuide: "Apartments £300k–£650k; townhouses £700k–£1.3m; crescent homes £1.5m+.",
    whyInvest: "Enduring demand from professionals, students and families keeps voids low and values resilient in this blue-chip postcode.",
  },
  {
    slug: "redland",
    salesPostcode: "BS6 6SN",
    city: "Bristol",
    name: "Redland",
    postcode: "BS6",
    tagline: "Leafy Victorian villas and a relaxed, family-friendly community",
    heroImage: "https://images.unsplash.com/photo-1784471397524-e867537ecf70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Redland is one of Bristol's most sought-after residential neighbourhoods — tree-lined streets of handsome Victorian villas, the green oasis of Redland Green, and easy access to both Clifton and the Gloucester Road.",
    intro2:
      "Expect substantial period family homes, garden flats and elegant conversions. It's especially popular with families thanks to outstanding local schools and a genuine sense of community.",
    highlights: ["Redland Green & its school", "Chandos Road cafés & delis", "Minutes from Clifton & Gloucester Road", "Redland station on the Severn Beach line"],
    transport: "Redland & Montpelier stations plus frequent buses reach the centre in ~15 minutes; the M32 is close.",
    schools: ["Redland Green School (Ofsted Outstanding)", "Bishop Road Primary", "Redmaids' High School (independent)"],
    vibe: "Green, gracious and family-oriented — village calm minutes from the buzz.",
    priceGuide: "Garden flats £325k–£500k; Victorian family homes £700k–£1.2m+.",
    whyInvest: "Top-rated schools drive relentless family demand and long tenancies — a dependable core-portfolio location.",
  },
  {
    slug: "bishopston",
    salesPostcode: "BS7 8NP",
    city: "Bristol",
    name: "Bishopston",
    postcode: "BS7",
    tagline: "Home of the Gloucester Road — Bristol's independent high-street heartland",
    heroImage: "https://images.unsplash.com/photo-1784471396524-d1d2493829a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Bishopston wraps around the Gloucester Road — reputedly the UK's longest stretch of independent shops, cafés and delis. It's vibrant, walkable and fiercely local, with rows of colourful Victorian terraces.",
    intro2:
      "The housing is largely two- and three-storey Victorian terraces, ideal for first-time buyers, young families and investors. Demand consistently outstrips supply.",
    highlights: ["Gloucester Road independents", "St Andrews Park", "Strong primary & secondary schools", "Easy centre & M32 access"],
    transport: "Frequent buses into the centre in ~15 minutes; the M32 (J2/J3) is minutes away for the M4.",
    schools: ["Bishop Road Primary (Outstanding)", "Ashley Down Primary", "Fairfield High School"],
    vibe: "Independent, sociable and buzzing — the beating heart of north Bristol.",
    priceGuide: "Terraces £425k–£650k; larger family homes £700k+.",
    whyInvest: "High tenant demand from young professionals and sharers, with consistently strong rental yields.",
  },
  {
    slug: "southville",
    salesPostcode: "BS3 1DR",
    city: "Bristol",
    name: "Southville",
    postcode: "BS3",
    tagline: "Creative, colourful and on the rise — North Street, the Tobacco Factory & Upfest",
    heroImage: "https://images.unsplash.com/photo-1784471397929-f1cdb3a5ce9b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    intro:
      "Southville and neighbouring Bedminster have transformed into one of Bristol's most creative quarters — North Street's independents, the Tobacco Factory theatre and market, and Europe's largest street-art festival, Upfest.",
    intro2:
      "Colourful Victorian and Edwardian terraces dominate, drawing young families, creatives and professionals who want character, community and quick access to the harbourside.",
    highlights: ["North Street & the Tobacco Factory", "Upfest street art", "Riverside & harbourside walks", "Ashton Court on the doorstep"],
    transport: "A short walk or cycle over the river to the centre and harbourside; excellent bus links and the A370 west.",
    schools: ["Ashton Gate Primary", "Southville Primary (Good)", "Ashton Park School (secondary)"],
    vibe: "Arty, energetic and community-led — Bristol's coolest up-and-comer.",
    priceGuide: "Terraces £375k–£575k; larger period homes £600k+.",
    whyInvest: "Rapid regeneration and a young renter base make Southville a strong growth-and-yield play.",
  },
];

export const CITIES = ["Bath", "Bristol"];

export const getAreaGuide = (slug) => AREA_GUIDES.find((a) => a.slug === slug);
